"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Switch", {
    enumerable: true,
    get: function() {
        return Switch;
    }
});
var _react = _interop_require_default(require("react"));
var _react1 = require("@chakra-ui/react");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var generateRandomId = function() {
    return Math.random().toString(36).slice(2);
};
var Switch = function(_param) {
    var label = _param.label, _param_labelPosition = _param.labelPosition, labelPosition = _param_labelPosition === void 0 ? "left" : _param_labelPosition, id = _param.id, props = _object_without_properties(_param, [
        "label",
        "labelPosition",
        "id"
    ]);
    var componentId = id !== null && id !== void 0 ? id : "cmpsr.".concat(generateRandomId());
    var isLeftLabel = labelPosition === "left";
    var _useMultiStyleConfig = (0, _react1.useMultiStyleConfig)("Switch", {
        size: props.size,
        isDisabled: props.isDisabled
    }), labelStyle = _useMultiStyleConfig.label;
    return _react.default.createElement(_react1.FormControl, {
        display: "flex",
        alignItems: "center",
        "data-testid": "cmpsr.switch",
        gap: "0.5rem"
    }, label && _react.default.createElement(_react1.FormLabel, _object_spread_props(_object_spread({}, labelStyle), {
        "data-testid": "cmpsr.switch-".concat(labelPosition, "-label"),
        htmlFor: componentId,
        order: isLeftLabel ? "1" : "2"
    }), label), _react.default.createElement(_react1.Switch, _object_spread_props(_object_spread({}, props), {
        id: componentId,
        order: isLeftLabel ? "2" : "1"
    })));
};
